import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import SEO from '../common/SEO';
import ColorSwitcher from '../elements/switcher/ColorSwitcher';
import { FaLock, FaUser, FaArrowLeft, FaShieldAlt } from 'react-icons/fa';

const AdminLogin = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleLogin = (e) => {
        e.preventDefault();
        // Hanya izinkan user ibanez dengan password baru
        if (
            username.trim().toLowerCase() === 'ibanez' &&
            password === 'R4tn454r1'
        ) {
            localStorage.setItem('ookey_admin_preview', 'true');
            window.dispatchEvent(new Event('storage'));
            navigate('/');
        } else {
            setError('Username atau password salah! Silakan coba lagi.');
        }
    };

    return (
        <>
            <SEO title="Admin Preview Login" />
            <ColorSwitcher />
            <main className="main-wrapper">
                <div className="section section-padding-equal d-flex align-items-center justify-content-center" style={{ minHeight: '100vh', background: 'var(--color-dark-2, #0d0e1a)' }}>
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-5 col-md-8">
                                <div className="contact-form-box shadow-box p-4 p-md-5" style={{ borderRadius: '24px', background: '#181926', border: '1px solid rgba(255, 255, 255, 0.12)' }}>
                                    <div className="text-center mb-4">
                                        <div style={{ width: '64px', height: '64px', borderRadius: '50%', background: 'linear-gradient(135deg, #5956E9 0%, #FFDC60 100%)', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', marginBottom: '16px', color: '#fff', fontSize: '24px' }}>
                                            <FaShieldAlt />
                                        </div>
                                        <h3 className="title text-white mb-2" style={{ fontWeight: 700, color: '#ffffff' }}>Admin Preview Mode</h3>
                                        <p style={{ fontSize: '14px', color: '#a0a5b8' }}>Masuk untuk meninjau dan mengedit tampilan web sebelum dipublikasikan secara umum.</p>
                                    </div>

                                    {error && (
                                        <div className="alert alert-danger py-2 px-3 mb-4" style={{ borderRadius: '12px', fontSize: '14px' }}>
                                            {error}
                                        </div>
                                    )}

                                    <form onSubmit={handleLogin}>
                                        <div className="form-group mb-4">
                                            <label className="mb-2 d-block text-start" style={{ fontSize: '14px', color: '#e2e8f0', fontWeight: 600 }}>Username</label>
                                            <div className="d-flex align-items-center" style={{ background: '#25273c', borderRadius: '14px', border: '1px solid #3d4160', padding: '4px 14px' }}>
                                                <span style={{ color: '#8e94b2', marginRight: '10px', fontSize: '16px', display: 'flex', alignItems: 'center' }}><FaUser /></span>
                                                <input 
                                                    type="text" 
                                                    className="form-control" 
                                                    style={{ background: 'transparent', border: 'none', color: '#ffffff', fontSize: '15px', padding: '10px 0', outline: 'none', boxShadow: 'none' }}
                                                    placeholder="Masukkan username" 
                                                    value={username}
                                                    onChange={(e) => setUsername(e.target.value)}
                                                    required
                                                />
                                            </div>
                                        </div>

                                        <div className="form-group mb-4">
                                            <label className="mb-2 d-block text-start" style={{ fontSize: '14px', color: '#e2e8f0', fontWeight: 600 }}>Password</label>
                                            <div className="d-flex align-items-center" style={{ background: '#25273c', borderRadius: '14px', border: '1px solid #3d4160', padding: '4px 14px' }}>
                                                <span style={{ color: '#8e94b2', marginRight: '10px', fontSize: '16px', display: 'flex', alignItems: 'center' }}><FaLock /></span>
                                                <input 
                                                    type="password" 
                                                    className="form-control" 
                                                    style={{ background: 'transparent', border: 'none', color: '#ffffff', fontSize: '15px', padding: '10px 0', outline: 'none', boxShadow: 'none' }}
                                                    placeholder="Masukkan password" 
                                                    value={password}
                                                    onChange={(e) => setPassword(e.target.value)}
                                                    required
                                                />
                                            </div>
                                        </div>

                                        <button type="submit" className="axil-btn btn-fill-primary btn-large w-100 mb-3" style={{ borderRadius: '12px', padding: '14px', fontSize: '15px', fontWeight: 600 }}>
                                            Buka Preview Website
                                        </button>

                                        <div className="text-center mt-3">
                                            <Link to="/" style={{ fontSize: '14px', textDecoration: 'none', color: '#8e94b2', display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
                                                <FaArrowLeft /> Kembali ke Halaman Utama
                                            </Link>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <style>{`
                    input::placeholder {
                        color: #646b8c !important;
                    }
                    input:focus {
                        color: #ffffff !important;
                        background-color: transparent !important;
                    }
                `}</style>
            </main>
        </>
    );
};

export default AdminLogin;
